import type { PropsWithChildren } from 'react';

import { useVTab } from './hook';
import type { VTabContent as VTabContentType } from './type';

export const VTabContent = ({
  children,
  value,
}: PropsWithChildren<VTabContentType>) => {
  const { value: innerValue } = useVTab();

  if (value !== innerValue) {
    return null;
  }

  return children;
};

VTabContent.displayName = 'VTabContent';
